import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        acordionTitleContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            width: '100%'
        },
        acordionTitleDescription: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
        },
        containerKey:{
            width:'250px'
        },
        flex: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        titles: {
            marginTop: 2,
            paddingBottom: 1,
            borderBottom: `1px solid ${colors.color13}`
        },
        error: {
            alignItems: 'center',
            display: 'flex',
            color: colors.color19,
            gap: '3px',
            '& .MuiSvgIcon-root': {
                fontSize: '1rem'
            },
        },
        acordionTitleContainerArrow: (expanded: boolean) => ({
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            paddingBottom: 1,
            borderBottom: expanded ? `1px solid ${colors.color13}` : ''
        }),
        arrow: {
            padding: 0,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        },
        rotate: (expand: boolean | undefined) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
    }
}

export { useStyles }